import { useMemo } from "react"
import { useAccount } from "wagmi"
import { Contract } from "ethers"
import useBBBNetwork from "./useBBBNetwork"
import { useEthersSigner } from "./useEthersSigner"

export default function useContract<T extends Contract = Contract>(contractAddress: string, ABI: any): T | null {
    const signer = useEthersSigner()
    const {
        chain: { id: chainId }
    } = useBBBNetwork()

    const { address: account } = useAccount()

    /*console.log("useContract 000000000000000000000")
    console.log("address", address)
    console.log("chainId", chainId)
    console.log("signer", signer)
    console.log("abi", ABI)*/

    return useMemo(() => {
        if (!contractAddress || !signer || !ABI || !account) {
            return null
        }

        try {
            return new Contract(contractAddress, ABI, signer)
        } catch (error) {
            console.error("Failed To Get Contract", error)

            return null
        }
    }, [contractAddress, ABI, signer, account, chainId]) as T
}
